import { InstanceScreen } from 'component/navigation/instance';

export default function ProfileEditScreen() {
    return <InstanceScreen screenKey='edit' />;
}
